import { BoxProps, TextProps as TextStyle, BoxProps as ViewStyle } from '@jfs/ui-new'
import { ViewStyle as RNViewStyle } from 'react-native'
import { Colors } from '../../util/util'

const styles = (viewPortWidth: number) => {
  const isMobile = viewPortWidth < 620

  return {
    container: () =>
      ({
        width: '100%',
      } as ViewStyle),
    cardContainer: {
      // flexDirection: 'column',
      width: '100%',
      // flex: 1,
      paddingTop: isMobile ? 32 : 60,
    } as BoxProps,
    card: {
      backgroundColor: Colors.WHITE,
      shadowColor: Colors.HALF_WHITE,
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.4,
      mt: 35,
      shadowRadius: 4,
      zIndex: 4,
      minWidth: isMobile ? undefined : 308,
      paddingHorizontal: 15,
      alignSelf: 'center',
      borderRadius: 16,
      paddingVertical: 20,
    } as BoxProps,
    scrollContainer: () => ({ flexGrow: 1 } as RNViewStyle),
    formContainer: {
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      // paddingHorizontal: 24,
    } as ViewStyle,
    backImage: {
      width: 32,
      height: 32,
      // marginTop: 40,
      // marginStart: 25,
    } as ViewStyle,
    titleStyle: {
      fontSize: 18,
      fontWeight: 'bold',
      color: Colors.BLACK_21,
    } as TextStyle,
    subTitleStyle: {
      fontSize: 12,
      fontWeight: '300',
      color: Colors.LIGHT_BLACK,
    } as TextStyle,
    buttonContainer: {
      marginTop: isMobile ? 24 : 32,
      width: '100%',
      alignItems: 'center',
      marginBottom: isMobile ? 20 : 32,
    } as ViewStyle,
    errorStyle: { color: Colors.ERROR, marginLeft: 16 } as TextStyle,
    pwdCheckListContainer: {
      flexDirection: 'column',
    } as ViewStyle,
    checkBoxListContainer: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    } as ViewStyle,
    confirmPassword: {
      marginTop: 16,
    } as ViewStyle,
    eyeImgStyle: { height: 20, width: 20 } as ViewStyle,
    backImgStyle: { height: 32, width: 32 } as ViewStyle,
    imgStyle: {
      height: 32,
      pl: 16,
      width: 32,
      underlayColor: 'WHITE',
      // marginTop: 16,
    } as ViewStyle,
    mainContainer: {
      height: '100%',
      width: '100%',
      overflow: 'auto',
      backgroundColor: Colors.JIO_PRIMARY,
    } as ViewStyle,
    webFormContainer: {
      paddingHorizontal: 20,
      paddingTop: 20,
      paddingBottom: 28,
      maxWidth: isMobile ? viewPortWidth - 36 : 376,
    } as ViewStyle,
  }
}
export { styles }
